var map = {
	"./10ans.png": 344,
	"./11ans.png": 345,
	"./12ans.png": 346,
	"./3ans.png": 347,
	"./4ans.png": 348,
	"./5ans.png": 349,
	"./6ans.png": 350,
	"./7ans.png": 351,
	"./8ans.png": 352,
	"./9ans.png": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343;